import { useState } from "react";

import FilterIcon from "../icons/FilterIcon";
import SortIcon from "../icons/SortIcon";
import Filter from "../modals/Filter";
import SortBy from "../modals/SortBy";

const ResponsiveButton = ({
  selectedFilterKeys,
  setSelectedFilterKeys,
  filters,
  handleFilter,
  handleResetFilter,
  handleSorting,
  allSortingKeys,
  setSortName,
  isSearching = false,
  fromSearch,
  t,
}) => {
  const [showType, setShowType] = useState("");

  return (
    <>
      <div className="grid grid-cols-2 gap-3 lg:hidden">
        <button
          onClick={() => setShowType("filter")}
          className="flex items-center justify-center gap-2 px-4 py-2 text-white rounded-sm sm:justify-normal bg-primary"
        >
          <FilterIcon />
          <span className="text-xs font-semibold sm:text-base">
            {t("All Filter")}
          </span>
        </button>
        <button
          onClick={() => setShowType("sort")}
          className="flex items-center justify-center gap-2 px-4 py-2 border rounded-sm sm:justify-normal border-secondary-700"
        >
          <SortIcon />
          <span className="text-xs font-semibold sm:text-base">
            {t("Sort By")}
          </span>
        </button>
      </div>
      {showType == "filter" && (
        <div className="fixed top-0 left-0 flex items-center justify-center w-screen h-screen bg-black lg:hidden bg-opacity-60 z-modal">
          <Filter
            {...{
              setSelectedFilterKeys,
              selectedFilterKeys,
              filters,
              handleFilter,
              handleResetFilter,
              setShowType,
              fromSearch,
            }}
          />
        </div>
      )}

      {!isSearching ? (
        <>
          {showType == "sort" && (
            <div className="fixed top-0 left-0 flex items-center justify-center w-screen h-screen bg-black lg:hidden bg-opacity-60 z-modal">
              <SortBy
                {...{
                  handleSorting,
                  setShowType,
                  allSortingKeys,
                  setSortName
                }}
              />
            </div>
          )}
        </>
      ) : null}
    </>
  );
};

export default ResponsiveButton;
